var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { livequeueConsultationService } from 'ziphy-web-shared/basic/api';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { usePaginationInfinite } from 'ziphy-web-shared/basic/hooks';
import { Loader } from 'ziphy-web-shared/basic/lib/loaders';
import { PageNoResults, Title } from 'ziphy-web-shared/basic/lib/simple';
import $livequeueConsultation from '@core/src/store/livequeueConsultationsStore';
import Toolbar from '@nedoShared/features/layouts/toolbar/Toolbar';
import OrdersList from '../../nedoShared/modules/orders/OrdersList/OrdersList';
import styles from './MyOrdersPage.module.scss';
const MyOrdersPage = () => {
    const { t } = useTranslation();
    const [activeProgram, setActiveProgram] = useState('programs');
    const [totalCount, setTotalCount] = useState(null);
    const { ref, isLoading, data } = usePaginationInfinite({
        idKeyPath: '_id',
        fetchData: ({ limit, offset }) => __awaiter(void 0, void 0, void 0, function* () {
            if (totalCount > 0 && data.length >= totalCount) {
                return $livequeueConsultation.consultationsList;
            }
            const response = yield livequeueConsultationService.searchConsultations({
                limit: limit,
                client_role_ids: [$auth.currentRoleId],
                skip: offset,
            });
            setTotalCount(response.total);
            return response.results;
        }),
        limit: 15,
    }, []);
    return (_jsx("div", Object.assign({ className: "content" }, { children: _jsxs("div", Object.assign({ className: classNames('container', styles.contentInner) }, { children: [_jsx("div", Object.assign({ className: styles.headerMobile }, { children: _jsxs(Toolbar, Object.assign({ hasBurger: true, className: styles.toolbarMobile }, { children: [_jsx(Title, Object.assign({ size: 'h3', className: classNames(styles.titleMobile) }, { children: t('label.my_orders') })), _jsx("div", {})] })) })), _jsx(Title, Object.assign({ size: 'h1', className: classNames('mb-30', styles.titleDesktop) }, { children: t('label.my_orders') })), _jsx(OrdersList, { orders: data, totalCount: totalCount }), isLoading ? _jsx(Loader, {}) : !(data === null || data === void 0 ? void 0 : data.length) && _jsx(PageNoResults, {}), _jsx("div", { ref: ref })] })) }))
    // </WithLoaderWrapper>
    );
};
export default observer(MyOrdersPage);
